<div class="container-narrow my-5">
  <ng-container *ngIf="replyMode && !isReplyTokenValid">
    <div *ngIf="salonReviewsItem.salonReply"
         class="alert alert-info mb-5"
         role="alert"
         [translate]="'VISIT-REVIEWS.REPLY.ALREADY-REPLIED'">
    </div>
    <div *ngIf="!salonReviewsItem.salonReply"
         class="alert alert-info mb-5"
         role="alert"
         [translate]="'VISIT-REVIEWS.REPLY.INVALID-TOKEN'">
    </div>
  </ng-container>

  <app-visit-review-about-salon *ngIf="salonDetails"
                                [salonDetails]="salonDetails">
  </app-visit-review-about-salon>

  <div *ngIf="salonReviewsItem"
       class="card border-0 shadow mb-5">
    <div class="card-body py-4">
      <app-review-item [review]="salonReviewsItem"></app-review-item>
    </div>
  </div>

  <ng-container *ngIf="replyMode">
    <div *ngIf="formSubmitted"
         [@inOutAnimation]
         class="alert alert-success"
         role="alert"
         [translate]="'VISIT-REVIEWS.REPLY.SAVE-SUCCESS.TEXT'">
    </div>

    <app-visit-review-reply-form *ngIf="isReplyTokenValid && !formSubmitted"
                                 [@inOutAnimation]
                                 [visitReviewReplyFormData]="visitReviewReplyFormData"
                                 (formSubmitted)="replyFormSubmitted()">
    </app-visit-review-reply-form>

  </ng-container>
</div>
